import App from './app';

export { App } from './app';

export default App;
